import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { teacher } from '../model/teacher';
@Injectable({
  providedIn: 'root'
})
export class StudentactiveService {
  readonly APIUrl = "https://api.stnhd.com/api/"
  //readonly APIUrl = "https://localhost:44301/api/"

  constructor(private http: HttpClient) { }

  getListActive(): Observable<any> {
    return this.http.get<any[]>(this.APIUrl + "StudentActive/getAllListStudentActive");
  }

  delStudentActive(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "StudentActive/delStudentActive", model);
  }
  getReport(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "StudentActive/getReport", model);
  }
}
